export default __webpack_public_path__ + "static/media/oro.a265a415.png";